<template>
	<div id="PageHeader">
		<nav-mobile v-if="deviceType == 'mobile'" :menu-list="menuList" @menuchange="menuChangeFun"></nav-mobile>
		<nav-pc v-if="deviceType == 'pc'" :menu-list="menuList" @menuchange="menuChangeFun"></nav-pc>
	</div>
</template>

<script>
	import PageHeaderPCComponent from "./PageHeaderPC.vue"
	import PageHeaderMobileComponent from "./PageHeaderMobile.vue"
	export default {
		name: 'PageHeader',
		components: {
			"nav-mobile": PageHeaderMobileComponent,
			"nav-pc": PageHeaderPCComponent
		},
		data() {
			return {
				menuList: [{
					name: "首页",
					path: "/",
					pathName: "Home",
					active: false,
				}, {
					name: "关于我们",
					path: "/about",
					pathName: "AboutUs",
					active: false,
				}, {
					name: "服务中心",
					path: "/productCenter",
					pathName: "ProductCenter",
					active: false,
				}, {
					name: "门店网点",
					path: "/storeOutlets",
					pathName: "StoreOutlets",
					active: false,
				}, {
					name: "联系我们",
					path: "/contactUs",
					pathName: "ContactUs",
					active: false,
				}],
				deviceType: ""
			}
		},
		methods: {
			deviceTypeChangeFun() {
				this.deviceType = this.$store.state.deviceType;
			},menuChangeFun(res){
				let mueuItem = this.menuList[res.detail.value];
				if(this.$route.path == mueuItem.path){
					
				}else{
					this.$router.push(mueuItem.path);
				}
				util.scrollTo(0,0, false);
			}
		},
		created() {
			let routePath = this.$route.path;
			this.menuList.forEach((item,index)=>{
				if(item.path==routePath){
					item.active = true;
				}
			})
			this.deviceTypeChangeFun();
		},
		computed: {
			getDeviceTypeFun: function() {
				return this.$store.state.deviceType;
			}
		},
		watch: {
			getDeviceTypeFun() {
				this.deviceTypeChangeFun();
			}
		}
	}
</script>

<style scoped="scoped">
</style>
